import { Capacitor } from '@capacitor/core'

export default {
  state: {
    documentBottomCheck: false,
    atDocumentBottom: false,
    lastKnownScrollPosition: 0,
    hideBecauseScroll: false,
    ignoreScrollEvents: false,
    fullscreenComponent: false,
    fullModalPositions: [],
    stickyContentHeight: 0,
    appContentWidth: 0,
    consented3rdPartyCookies: Capacitor.isNativePlatform()
  },
  getters: {
    documentBottomCheck: state => state.documentBottomCheck,
    atDocumentBottom: state => state.atDocumentBottom,
    lastKnownScrollPosition: state => state.lastKnownScrollPosition,
    hideBecauseScroll: state => state.hideBecauseScroll,
    ignoreScrollEvents: state => state.ignoreScrollEvents,
    fullscreenComponent: state => state.fullscreenComponent,
    stickyContentHeight: state => state.stickyContentHeight,
    fullModalPositions: state => state.fullModalPositions,
    appContentWidth: state => state.appContentWidth,
    consented3rdPartyCookies: state => state.consented3rdPartyCookies,
  },
  mutations: {
    SET_DOCUMENT_BOTTOM_CHECK(state, bool) {
      state.documentBottomCheck = bool
    },
    SET_AT_DOCUMENT_BOTTOM(state, bool) {
      state.atDocumentBottom = bool
    },
    SET_LAST_KNOWN_SCROLL_POSITION(state, number) {
      state.lastKnownScrollPosition = number
    },
    SET_HIDE_BECAUSE_SCROLL(state, bool) {
      state.hideBecauseScroll = bool
    },
    SET_IGNORE_SCROLL_EVENTS(state, bool) {
      state.ignoreScrollEvents = bool
    },
    SET_FULLSCREEN_COMPONENT(state, bool) {
      state.fullscreenComponent = bool
    },
    SET_STICKY_CONTENT_HEIGHT(state, height) {
      state.stickyContentHeight = height
    },
    SET_FULL_MODAL_POSITIONS(state, array) {
      state.fullModalPositions = array
    },
    PUSH_TO_FULL_MODAL_POSITIONS(state,position) {
      state.fullModalPositions.push(position)
    },
    POP_FROM_FULL_MODAL_POSITIONS(state) {
      state.fullModalPositions.pop()
    },
    SET_APP_CONTENT_WIDTH(state, width) {
      state.appContentWidth = width
    },
    SET_CONSENTED_3RD_PARTY_COOKIES(state, bool) {
      state.consented3rdPartyCookies = bool
    }
  },
  actions: {
    hideWithScroll({ state, commit }, bool) {
      if (state.hideBecauseScroll !== bool) {
        commit('SET_IGNORE_SCROLL_EVENTS', true)
        commit('SET_HIDE_BECAUSE_SCROLL', bool)
        setTimeout(() => {
          commit('SET_IGNORE_SCROLL_EVENTS', false)
        }, 800)
      }
    }
  }
}